// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"b12c7d8c","232":"3d0a8dc9","269":"5d12d758","525":"2d57c2e8","657":"0fc32d9e","666":"caad0a7a","726":"63e59fed","731":"4764a067","886":"c424a05b","908":"ab974963"}[chunkId] + ".chunk.js";
};